var _g;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgLogo(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 171.9,
    height: 121.854,
    viewBox: "0 0 171.9 121.854",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "VSDV_Logo",
    "data-name": "VSDV Logo",
    transform: "translate(-228.261 -160.899)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_7",
    "data-name": "Group 7",
    transform: "translate(261.362 160.899)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_1",
    "data-name": "Path 1",
    d: "M364.644,191.493l4.631-14.719A47.23,47.23,0,0,0,319.1,191.493H302.372a60.948,60.948,0,0,1,105.7,0Z",
    transform: "translate(-302.372 -160.899)",
    fill: "#cb0a32"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_2",
    "data-name": "Path 2",
    d: "M345.53,365.253l-4.6,14.622a47.2,47.2,0,0,0,50.42-14.622h16.728a60.947,60.947,0,0,1-105.69,0Z",
    transform: "translate(-302.38 -273.982)",
    fill: "#cb0a32"
  })), /*#__PURE__*/React.createElement("path", {
    id: "Path_3",
    "data-name": "Path 3",
    d: "M258.205,247.919,250.8,277.4l-7.4-29.483H228.261l13.885,44.134h16.811l13.884-44.134Z",
    transform: "translate(0 -48.154)",
    fill: "#001c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_4",
    "data-name": "Path 4",
    d: "M543.273,247.919l-7.4,29.483-7.4-29.483H513.33l13.884,44.134h16.811l13.884-44.134Z",
    transform: "translate(-157.748 -48.154)",
    fill: "#001c43"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_5",
    "data-name": "Path 5",
    d: "M398.273,252.607a14.141,14.141,0,0,0-6.131-3.508,34.468,34.468,0,0,0-9.8-1.18H338.9a32.545,32.545,0,0,0-8.022.744,13.927,13.927,0,0,0-5.328,2.553,9.655,9.655,0,0,0-2.965,4.156,16.455,16.455,0,0,0-.924,5.712v.814a20.783,20.783,0,0,0,.587,5.3,8.215,8.215,0,0,0,2.068,3.683,11.873,11.873,0,0,0,4.114,2.576,36,36,0,0,0,6.754,1.8l4.451.815a6.38,6.38,0,0,1,2.358.764,2.327,2.327,0,0,1,.667,1.988,2.479,2.479,0,0,1-.756,2.079,4.783,4.783,0,0,1-2.753.553h-6.738c-1.555,0-3.2-.013-6.522-.04-2.033-.017-4.7-.038-8.353-.065l-3.369,10.709c9.414.04,11.73.071,12.981.087q2.41.031,4.353.031h7.334a43.736,43.736,0,0,0,8.787-.747,14.172,14.172,0,0,0,5.7-2.4,9.022,9.022,0,0,0,3.082-4.211,18.966,18.966,0,0,0,.926-6.31V277.7a20.044,20.044,0,0,0-.557-4.952,8.656,8.656,0,0,0-1.95-3.688,11.7,11.7,0,0,0-3.775-2.667,25.689,25.689,0,0,0-6.052-1.8l-6.331-1.19a6.731,6.731,0,0,1-2.29-.7c-.41-.279-.609-.869-.609-1.8a2.206,2.206,0,0,1,.72-1.824,4.462,4.462,0,0,1,2.662-.557h41.381a12.488,12.488,0,0,1,3.469.476,4.588,4.588,0,0,1,3.566,3.662,24.45,24.45,0,0,1,.352,4.448v5.767a15.931,15.931,0,0,1-.352,3.663,4.949,4.949,0,0,1-1.257,2.374A5.238,5.238,0,0,1,384,280.162a6.355,6.355,0,0,1-1.311.3l-.437.036-.328.016H375.26V262.06l-1.352.255a25.646,25.646,0,0,0-6.052,1.8,11.711,11.711,0,0,0-3.776,2.668,8.661,8.661,0,0,0-1.949,3.687c-.07.272-.133.5-.19.708a8.349,8.349,0,0,0-.367,2.832s.017,4.189.017,5.417v12.626h21.127a30.709,30.709,0,0,0,9.543-1.272,13.171,13.171,0,0,0,9.209-9.762,33.028,33.028,0,0,0,.933-8.212v-5.7a34.881,34.881,0,0,0-.933-8.557A12.978,12.978,0,0,0,398.273,252.607Z",
    transform: "translate(-47.539 -48.154)",
    fill: "#001c43"
  }))));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgLogo);
export default __webpack_public_path__ + "static/media/logo.3977e9a7c337ec99f3cd0726173bc8f0.svg";
export { ForwardRef as ReactComponent };